import { Button, Collapse, Divider, notification, Space } from 'antd';
import React, { useEffect, useRef, useState } from 'react';
import { useSelector } from 'react-redux';
import Screenback from '../../../../components/screenBack/screenBack';
import { UserTypeDict } from '../../../../utils/settings';
import {
  getReportsCSVFileAction,
  getReportsCSVFileForRetailerAction,
  getTotalSaleTotalReportsBuy,
} from '../../action/util_action';
import OrderBookingTable from '../orders/OrderBookingTable';
import UserReportMontlyCard from './userReportMontlyCard';
import { CSVLink } from 'react-csv';
import DispatchPlanningUserReports from '../orderBooking/orderBookingReport';
import { getIsFMCG } from '../../../auth/action';
const { Panel } = Collapse;

const reportEnum = {
  SALES: 1,
  PO: 2,
};

const UserReports = () => {
  const [userReports, setUserReports] = useState([]);

  // Tabs
  const [activeTab, setActiveTab] = useState(reportEnum['SALES']);

  // ----- CSV --------
  const [csvData, setCsvData] = useState([]);
  const csvRef = useRef();

  const { loginUser } = useSelector((state) => {
    return {
      loginUser: state.loginReducer.loginUser,
    };
  });

  const isFMCG = getIsFMCG();

  const isDistributor = true;
  const isRetailer = true;
  const isDistributorAndRetailer = true;

  const getReportsCSVFilte = async () => {
    if (isDistributor) {
      const data = await getReportsCSVFileAction();
      if (data.error) {
        return notification.error({ message: data.message });
      }
      setCsvData(data.data);
    }

    if (isRetailer) {
      const data = await getReportsCSVFileForRetailerAction();
      if (data.error) {
        return notification.error({ message: data.message });
      }
      setCsvData(data.data);
    }
  };

  const getAlalytics = async () => {
    const { error, data, message } = await getTotalSaleTotalReportsBuy();

    if (!error) {
      if (
        loginUser.company_details.company_type === UserTypeDict['RETAILER'] ||
        loginUser.company_details.company_type === UserTypeDict['ASSOCIATE']
      ) {
        setUserReports(data.retailer_buy ? data.retailer_buy : []);
      } else {
        setUserReports(data.distributor_buy ? data.distributor_buy : []);
      }
    } else notification.error({ message: message });
  };

  useEffect(() => {
    getAlalytics();
    getReportsCSVFilte();
  }, []);

  return (
    <div
      style={{ width: '100%' }}
      className='userReports'
    >
      <Screenback />

      <div
        style={{
          flexDirection: 'row',
          display: 'flex',
          justifyContent: 'space-around',
          width: '100%',
        }}
      >
        <h4
          onClick={() => setActiveTab(reportEnum['SALES'])}
          className='tabtext'
          style={{
            backgroundColor:
              activeTab === reportEnum['SALES'] ? '#f49d3f' : '#fdecdb',
            color: activeTab === reportEnum['SALES'] ? 'white' : 'gray',
          }}
        >
          Sales Report
        </h4>
        {((!isFMCG && isDistributor) || isDistributorAndRetailer) && (
          <h4
            onClick={() => setActiveTab(reportEnum['PO'])}
            className='tabtext'
            style={{
              backgroundColor:
                activeTab === reportEnum['PO'] ? '#f49d3f' : '#fdecdb',
              color: activeTab === reportEnum['PO'] ? 'white' : 'gray',
            }}
          >
            PO Report
          </h4>
        )}
      </div>
      {/* --------- Sales Report --------- */}
      {activeTab === reportEnum['SALES'] && (
        <div
          style={{ width: '100%' }}
          className='userReports'
        >
          <Space
            direction='vertical'
            style={{ width: '100%', marginTop: '1rem' }}
          >
            {(isDistributor || isRetailer) && csvData.length > 0 && (
              <>
                <Button
                  block
                  type='dashed'
                  style={{
                    width: '10rem',
                    marginLeft: '1rem',
                    marginTop: '1rem',
                  }}
                  className='addproduct-btn retailer__addbtn'
                  onClick={() => csvRef.current.link.click()}
                >
                  <b className='btnText'> Download Reports</b>
                </Button>
                <div style={{ opacity: 0, width: 0, height: 0 }}>
                  <CSVLink
                    data={csvData ? csvData : []}
                    ref={csvRef}
                    filename={'financialYearReport'}
                  />
                </div>
              </>
            )}
            {Array.isArray(userReports) &&
              userReports.map((report, indexReport) => {
                const finnancialQty = Number(
                  report?.details?.reduce(
                    (acc, curr) =>
                      acc + curr?.sells_quantity?.quantity_in_metric_ton,
                    0,
                  ),
                ).toFixed(3);
                const tableDataCompany = {
                  rows: ['Financial Year', 'QTY'],
                  tableData: [1].map(() => [
                    report.financial_year,
                    Number(finnancialQty).toFixed(3),
                  ]),
                  onRowClick: (index) => {},
                };
                return (
                  <Collapse
                    defaultActiveKey={['1']}
                    expandIcon={() => <div style={{ display: 'none' }} />}
                    ghost={true}
                  >
                    <Panel
                      header={<OrderBookingTable data={tableDataCompany} />}
                      key={indexReport}
                    >
                      {report.details.map((i, index) => (
                        <>
                          <UserReportMontlyCard item={i} />
                          <Divider />
                        </>
                      ))}
                    </Panel>
                  </Collapse>
                );
              })}
          </Space>
        </div>
      )}
      {/* -------- Po Report ----------- */}
      {activeTab === reportEnum['PO'] && (
        <>
          {(isDistributor || isRetailer) && csvData.length > 0 && (
            <>
              <Button
                block
                type='dashed'
                style={{
                  width: '10rem',
                  marginLeft: '1rem',
                  marginTop: '2rem',
                }}
                className='addproduct-btn retailer__addbtn'
                onClick={() => csvRef.current.link.click()}
              >
                <b className='btnText'> Download Reports</b>
              </Button>
              <div style={{ opacity: 0, width: 0, height: 0 }}>
                <CSVLink
                  data={csvData ? csvData : []}
                  ref={csvRef}
                  filename={'financialYearReport'}
                />
              </div>
            </>
          )}
          <DispatchPlanningUserReports />
        </>
      )}
    </div>
  );
};

export default UserReports;
